module.exports = __webpack_public_path__ + "static/media/inspire19Tom.e8a1f96c.jpeg";